export function formatDate(e, type = 1) {
	if (e) {
		let arr = e.split(" ");
		let date = arr[0].split('-');
		switch (type) {
			case 1: //MM月dd日
				return date[1] + '月' + date[2] + '日';
			case 2: //MM月dd日 HH:mm:ss
				return date[1] + '月' + date[2] + '日 ' + arr[1];
			default:
				return '';
		}
		return
	} else {
		return '';
	}
}
export function handlerImg(e) {
	if (!/https?:/.test(e)) {
		return 'http://api.iyoucang.com' + (/\/admin/.test(e) ? e : '/admin/sys-file/cargoee/' + e)
	} else {
		return e || "";
	}
}
export function hideName(e) {
	return e ? e.substring(0, 1) + '**' + e.substr(e.length - 1) : ''
}
export function handlerWeatherWithdraw(str, type) {
	return type == 2 ? str : "排舱";
}
export function keepTwoDecimalFull(num) {  
            var result = parseFloat(num);  
            if (isNaN(result)) {  
                console.log('传递参数错误，请检查！');  
                return false;  
            }  
            result = Math.round(num * 100) / 100;  
            var s_x = result.toString(); //将数字转换为字符串
            
            var pos_decimal = s_x.indexOf('.'); //小数点的索引值
            
             // 当整数时，pos_decimal=-1 自动补0  
             if (pos_decimal < 0) {  
                 pos_decimal = s_x.length;  
                 s_x += '.';  
             }

             // 当数字的长度< 小数点索引+2时，补0  
             while (s_x.length <= pos_decimal + 2) {  
                 s_x += '0';  
         }  
             return s_x;  
    }  


// WEBPACK FOOTER //
// ./src/filters/index.js